import React from 'react';
import styled from 'styled-components';
import { colors } from 'assets/styled/tokens';
import { CalendarEvent, EventColorSet } from 'pages/Agenda/utils';
import { AgendaEventCard } from './AgendaEventCard';

const MobileDayCardListWrapper = styled.div`
  width: 100%;
  min-width: 0;
`;

const HorasPrevistasLabel = styled.div`
  font-family: Roboto;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.3px;
  color: ${colors.gray};
  margin-bottom: 8px;
`;

const CardsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  min-width: 0;
`;

interface MobileDayCardListProps {
  events: CalendarEvent[];
  getColorSet: (event: CalendarEvent) => EventColorSet;
  isCompletedView: boolean;
  horasPrevistasLabel: string;
}

export const MobileDayCardList: React.FC<MobileDayCardListProps> = ({
  events,
  getColorSet,
  isCompletedView,
  horasPrevistasLabel,
}) => {
  return (
    <MobileDayCardListWrapper>
      <HorasPrevistasLabel>{horasPrevistasLabel} previstas</HorasPrevistasLabel>
      <CardsList>
        {events.map(event => (
          <AgendaEventCard
            key={event.id}
            event={event}
            colorSet={getColorSet(event)}
            isCompletedView={isCompletedView}
          />
        ))}
      </CardsList>
    </MobileDayCardListWrapper>
  );
};
